import { toast } from "sonner";
export const setUserToken = async (data) => {
  try {
    localStorage.setItem("token", JSON.stringify(data));
  } catch (error) {
    console.log("Error on setting User Token", error);
  }
};

export const getUserToken = async () => {
  try {
    let userToken = localStorage.getItem("token");
    if (userToken) {
      return JSON.parse(userToken);
    }
    return null;
  } catch (error) {
    console.log("Error on getting User Token", error);
    return null;
  }
};

export const removeUserToken = async () => {
  try {
    localStorage.removeItem("token");
  } catch (error) {
    console.log("Error on Removing User Token", error);
  }
};

export const setUserData = async (data) => {
  try {
    localStorage.setItem("user", JSON.stringify(data));
  } catch (error) {
    console.log("Error on setting User Data", error);
  }
};

export const getUserData = async () => {
  try {
    const userData = localStorage.getItem("user");
    if (userData) {
      return JSON.parse(userData);
    }
    return null;
  } catch (error) {
    console.log("Error on getting User Data", error);
    return null;
  }
};

export const removeUserData = async () => {
  try {
    localStorage.removeItem("user");
  } catch (error) {
    console.log("Error on Removing User Data", error);
  }
};

export const handleErrors = async (res, navigate, mode) => {
  try {
    const status = res?.status || null;
    const message = res?.response?.data?.message || "";
    if (status === 401) {
      toast.error(`${mode || ""} ${message || "Invalid Token"}`, {
        duration: 5000,
      });
      navigate("/login");
    } else if (status === 423) {
      toast.error(
        `${mode || ""} ${
          message ||
          "Your account is inactive. Please contact support to activate it."
        }`,
        { duration: 5000 },
      );
      navigate("/login");
    } else if (status === 403) {
      toast.error(`${mode || ""} ${message || "Un-Athorized"}`, {
        duration: 5000,
      });
    } else if (status === 404) {
      toast.error(`${mode || ""} ${message || "Data Not found"}`, {
        duration: 5000,
      });
    } else if (status === 500) {
      toast.error(
        `${mode || ""} ${message || "Server Error, please try again later!"}`,
        {
          duration: 5000,
        },
      );
    } else {
      toast.error(
        `${mode || ""} ${message || "Server Error, please try again later!"}`,
        {
          duration: 5000,
        },
      );
    }
  } catch (error) {
    console.log("Error on Handling Error", error);
  }
};

export const haveToLogin = async (navigate) => {
  removeUserData();
  removeUserToken();
  navigate("/login");
};

export const maskContactNumber = (e) => {
  let value = e.target.value.replace(/\D/g, "");

  let countryCode = "";
  if (value.length > 10) {
    countryCode = `+${value.slice(0, value.length - 10)} `;
    value = value.slice(-10);
  }

  if (value.length <= 3) {
    value = `${value}`;
  } else if (value.length <= 6) {
    value = `(${value.slice(0, 3)}) ${value.slice(3)}`;
  } else {
    value = `(${value.slice(0, 3)}) ${value.slice(3, 6)}-${value.slice(6, 10)}`;
  }

  return `${countryCode}${value}`;
};

export const validateImage = (file) => {
  const maxSize = 10 * 1024 * 1024; // 10MB
  const allowedTypes = ["image/png", "image/jpeg", "image/webp", "image/jpg"];

  if (file.size > maxSize) {
    toast.error("File size exceeds 10MB limit.");
    return false;
  }

  if (!allowedTypes.includes(file.type)) {
    toast.error("Invalid file format. Please upload PNG, WebP, or JPEG/JPG.");
    return false;
  }

  return true;
};


export const formatDateForInput = (dateVal) => {
  if (!dateVal) return "";
  try {
    const d = new Date(dateVal);
    if (isNaN(d.getTime())) return "";
    return d.toISOString().split("T")[0];
  } catch (e) {
    return "";
  }
};

export const getTodayDateString = () => {
  try {
    return new Date().toISOString().split("T")[0];
  } catch (e) {
    return "";
  }
};

export const getNextWeekDateString = () => {
  try {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 7);
    return tomorrow.toISOString().split("T")[0];
  } catch (e) {
    return "";
  }
};

export const stringToColor = (str, lightness = 80) => {
  let hash = 0;

  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = "#";

  for (let i = 0; i < 3; i++) {
    let value = (hash >> (i * 8)) & 0xff;
    value = Math.min(255, value + lightness);
    color += value.toString(16).padStart(2, "0");
  }

  return color;
};